<template>
    <span>{{ formattedAmount }}</span>
</template>

<script setup lang="ts">
    import { computed } from "vue"
    import { formatCurrency } from "@/util/currency"

    const props = defineProps<{
        amount?: number | null
        includeCents?: boolean | false
    }>()

    const formattedAmount = computed(() =>
        formatCurrency(props.amount, "cents", props.includeCents) ?? ""
    )
</script>
